import { inject } from '@angular/core';
import { ResourceTablePresetAdapterCache } from '@kinet-open-network/client/shared/ui';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { AuthApiActions } from './auth.actions';

export const clearCache$ = createEffect(
  (
    actions$ = inject(Actions),
    presetCache = inject(ResourceTablePresetAdapterCache, { optional: true }),
  ) => {
    return actions$.pipe(
      ofType(AuthApiActions.logoutSuccess, AuthApiActions.loginSuccess),
      tap(() => presetCache?.clear()),
    );
  },
  {
    functional: true,
    dispatch: false,
  },
);
